module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/文字logo.c4d99.png";